export const provinceCodes = [
    {
        "label": "Ontario",
        "value": "ON",
    },
    {
        "label": "Quebec",
        "value": "QC",
    },
    {
        "label": "Nova Scotia",
        "value": "NS",
    },
    {
        "label": "New Brunswick",
        "value": "NB",
    },
    {
        "label": "Manitoba",
        "value": "MB",
    },
    {
        "label": "British Columbia",
        "value": "BC",
    },
    {
        "label": "Prince Edward Island",
        "value": "PE",
    },
    {
        "label": "Saskatchewan",
        "value": "SK",
    },
    {
        "label": "Alberta",
        "value": "AB",
    },
    {
        "label": "Newfoundland",
        "value": "NL",
    },
    {
        "label": "Northwest Territories",
        "value": "NT",
    },
    {
        "label": "Yukon",
        "value": "YK",
    },
    {
        "label": "Nunavut",
        "value": "NU",
    },
];
//# sourceMappingURL=province-codes.js.map